import CanvasTypes from '~/constants/types/CanvasTypes';
import {guessSize, verifyDimensions} from '~/actions/TextActions';
import {createAction} from 'redux-actions';
import {getIcons, sleevePrintEnabled} from '~/selectors/CanvasSelectors';
import {isNamesOrNumbers, isText} from '~/data/accessors/icon';
import {
  getAnchorStyleId,
  isAnchorEmbroidered,
  isSleeveDecoEligibleStyle
} from '~/selectors/ProductSelectors';

export const changeView = (payload, meta) => dispatch => {
  dispatch({
    type: CanvasTypes.CHANGE_VIEW,
    payload: payload,
    meta: meta
  });
};
export const clear = createAction(CanvasTypes.CLEAR);
export const clearRecentUploads = createAction(
  CanvasTypes.CLEAR_RECENT_UPLOADS
);
export const disableCanvas = createAction(CanvasTypes.DISABLE);
export const disableCanvasArrowKeys = createAction(
  CanvasTypes.SET_DISABLE_ARROW_KEYS
);
export const enableSleevePrint = (payload, meta) => dispatch => {
  dispatch({
    type: CanvasTypes.ACTIVATE_SLEEVE_PRINT,
    payload: payload,
    meta: meta
  });
};
export const removeRecentUpload = createAction(
  CanvasTypes.REMOVE_RECENT_UPLOAD
);
export const setLabBlankLoad = createAction(CanvasTypes.SET_LAB_BLANK_LOAD);
export const showDesign = createAction(CanvasTypes.SHOW_DESIGN);

export const iconRendered = props => (dispatch, getState) => {
  const {iconId, width, height, viewportScale} = props;
  dispatch({
    type: CanvasTypes.ICON_RENDERED,
    payload: {
      iconId,
      width,
      height,
      viewportScale
    }
  });
  if (width || height) {
    const icon = getIcons(getState()).find(i => i.id === iconId);
    if (
      icon &&
      (isText(icon.type) || isNamesOrNumbers(icon.type)) &&
      !icon.verifying
    ) {
      if (!icon.converted) {
        dispatch(guessSize(icon, viewportScale));
      } else {
        dispatch(verifyDimensions(icon, viewportScale));
      }
    }
  }
};

export const enableSleeveNav = () => (dispatch, getState) => {
  const state = getState();
  const styleId = getAnchorStyleId(state);
  const decoEligible = isSleeveDecoEligibleStyle(state)(styleId);

  const alreadyEnabled = sleevePrintEnabled(state);
  const isEmbroidered = isAnchorEmbroidered(state);

  if (isEmbroidered && decoEligible && !alreadyEnabled) {
    dispatch(enableSleevePrint(true));
  }
};
